// extracted by mini-css-extract-plugin
module.exports = {"header":"BoutiqueHeader-header-0361"};